/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 指定存放路径上传
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  fileUploadDto: oss.FileUploadDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/oss/file/path`,
    data: fileUploadDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
